import { render, staticRenderFns } from "./AddCustomField.vue?vue&type=template&id=cf08a1ae&"
import script from "./AddCustomField.vue?vue&type=script&lang=js&"
export * from "./AddCustomField.vue?vue&type=script&lang=js&"
import style0 from "./AddCustomField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports